module.exports = __webpack_public_path__ + "static/october-1-e931d7c167d0c74a2598650f968075b6.png";